<template>
  <div class="row buscador-avanzado">
    <div class="col-md-12">
      

      <div v-if=" getCategory == 'cine' || getCategory == 'series' || getCategory == 'documentales' ">
        <h4 v-if=" getCategory != 'infantil' ">{{ $t('Buscador Avanzado') }}</h4>
        
        <div class="select-search-form">
          <button :class="(searchCategory == 'todos') ? 'buscador-btn active' : 'buscador-btn' " @click="setSearchCategory('todos')">{{ $t('Todos') }}</button>
          <button :class="(searchCategory == 'cine') ? 'buscador-btn active' : 'buscador-btn' " @click="setSearchCategory('cine')">{{ $t('Cine') }}</button>
          <button :class="(searchCategory == 'series') ? 'buscador-btn active' : 'buscador-btn' " @click="setSearchCategory('series')">{{ $t('Series') }}</button>
          <button :class="(searchCategory == 'documentales') ? 'buscador-btn active' : 'buscador-btn' " @click="setSearchCategory('documentales')">{{ $t('Documentales') }}</button>
        </div>

        <buscador-avanzado-cine-tv :searchCategory="searchCategory" class="mt40">
        </buscador-avanzado-cine-tv>
      </div>

      <!-- 
        Antes de inuficar CINE/TV
        <buscador-avanzado-csd :searchCategory="getCategory"
        v-if=" getCategory == 'cine' || getCategory == 'series' || getCategory == 'documentales' ">
      </buscador-avanzado-csd> -->

      <buscador-avanzado-musica 
        v-if=" getCategory == 'musica' ">
      </buscador-avanzado-musica>

      <buscador-avanzado-libros 
        v-if=" getCategory == 'libros' ">
      </buscador-avanzado-libros>

      <buscador-avanzado-infantil 
        v-if=" getCategory == 'infantil' ">
      </buscador-avanzado-infantil>

    </div>
  </div>
</template>

<i18n>
{
  "es": {
    "Buscador Avanzado": "Buscador Avanzado",
    "Todos": "Todos",
    "Cine": "Cine", 
    "Series": "Series",
    "Documentales": "Documentales"
  },
  "en": {
  },
  "ca": {
    "Buscador Avanzado": "Cercador avançat",
    "Todos": "Tots",
    "Cine": "Cine", 
    "Series": "Sèries",
    "Documentales": "Documentals"
  }
}
</i18n>

<script>
  import axios from 'axios'; 
  import { mapGetters } from 'vuex';
  //import BuscadorAvanzadoCsd from './BuscadorAvanzadoCsd.vue';
  import BuscadorAvanzadoCineTv from './BuscadorAvanzadoCineTv.vue';
  import BuscadorAvanzadoMusica from './BuscadorAvanzadoMusica.vue';
  import BuscadorAvanzadoLibros from './BuscadorAvanzadoLibros.vue';
  import BuscadorAvanzadoInfantil from './BuscadorAvanzadoInfantil.vue';

  export default {
    components: { BuscadorAvanzadoCineTv, BuscadorAvanzadoMusica, BuscadorAvanzadoLibros, BuscadorAvanzadoInfantil },
    data: () => {
      return{
        searchCategory: 'todos',
      }
    },
    mounted(){
    },
    computed: mapGetters(['getLocale', 'getApiUrl', 'getCategory']), 
    methods: {
      setSearchCategory(value){
        this.searchCategory = value;
      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
    },
    watch:{
    }
  }
</script>
